import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { getCsrfToken } from './csrf'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:8000',
  withCredentials: true
})

let isRefreshing = false
let pending401: Array<() => void> = []

http.interceptors.request.use((config) => {
  // Attach CSRF token when sending unsafe methods
  const method = (config.method ?? 'get').toUpperCase()
  const needsCsrf = method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS'
  if (needsCsrf) {
    const token = getCsrfToken()
    // Django expects the header name 'X-CSRFToken'
    if (token) config.headers['X-CSRFToken'] = token
  }
  return config
})

http.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as (InternalAxiosRequestConfig & { _retry?: boolean }) | undefined
    if (error?.response?.status === 401 && original && !original._retry) {
      original._retry = true
      if (isRefreshing) {
        await new Promise<void>((resolve) => pending401.push(resolve))
      } else {
        isRefreshing = true
        try {
          await http.get('/auth/session')
        } catch (_) {
          if (location.pathname !== '/login') location.assign('/login')
          isRefreshing = false
          pending401.forEach((fn) => fn())
          pending401 = []
          return Promise.reject(error)
        }
        isRefreshing = false
        pending401.forEach((fn) => fn())
        pending401 = []
      }
      // Retry original once
      return http(original)
    }
    return Promise.reject(error)
  }
)
